// extracted by mini-css-extract-plugin
export default {"checkbox":"PremiumCheckbox_checkbox__HOS5J","label":"PremiumCheckbox_label__fOyNv","opacity":"PremiumCheckbox_opacity__aBw0m"};